<app-menu-superior [user]="user" [button]="true" [title]="'LISTADO VENTAS'"></app-menu-superior>
<!-- 
@TODO
  MODIFICAR LA APARIENCIA DEL LISTADO
 -->

<ion-content fullscreen>

  <ion-grid class="ion-no-padding class-grid" style="font-size:12px;background-color: #7194a5;">
    <ion-row style="height: 100%;">
      <ion-col class="container ion-no-padding noScrollBar">
        <ion-row style="">
          <ion-col style="background-color: #7194a5; width:100%; " class="ion-no-padding verticalLeft">
            <mat-form-field (click)="picker.open()" style="width:100%;background-color: #7194a5;" 
              class="verticalLeft text-left">
              <mat-label style="margin-top: auto;">
                <span class="label-wrapper" style="font-size: 19px; color: white !important;">Seleccione una Fecha</span>
              </mat-label>
              <input style="color: #f8f9fa;width:100%;margin-bottom: auto;" matInput [matDatepicker]="picker" readonly
                (dateChange)="onBlur($event)" (keydown.enter)="picker.open()" [(ngModel)]="fecha" name="inputDatepicker">
              <mat-datepicker-toggle style="color: #f8f9fa; width:100%; transform: scale(1.5);" matSuffix
                [for]="picker"></mat-datepicker-toggle>
    
              <mat-datepicker style="color: #f8f9fa;" touchUi #picker></mat-datepicker>
            </mat-form-field>
          </ion-col>
        </ion-row>
        <ion-row class=" arribo MAIN-HEADER" *ngFor="let venta of ventas">
          <ion-col class="ion-no-padding">
            <ion-row class="paddingHeaders data-venta cabecera">
              <ion-col size="1" style="padding-left: 5px;">
                <fa-icon class="icons-fa" [icon]="faService.faShip" style="color:#a1a4ad"></fa-icon>
              </ion-col>
              <ion-col size="" class="verticalleft ion-no-padding paddingLeft"  style="font-weight: 500;">
                {{venta.proveedor}}</ion-col>
              <ion-col size="3" class="verticalRight ion-no-padding paddingRight" style="font-weight: 500;padding-right: 5px;">
                {{venta.cantidadTotal| number:'1.2-2':'es' }} KG</ion-col>
            </ion-row>
            <ion-row *ngFor="let adjudicacion of venta.adjudicaciones" class="linea"
              style="border-top:1px solid #f7f7f7;border-bottom:1px solid #f7f7f7">
              <ion-col>
                <ion-row>
                  <ion-col size="1" style="padding-left: 5px;">
                    <fa-icon class="icons-fa" [icon]="faService.faFish"></fa-icon>
                  </ion-col>
                  <ion-col size="8" class="verticalLeft ion-no-padding">{{adjudicacion.especie}}</ion-col>
                  <ion-col size="1">
                    <fa-icon class="icons-fa" [icon]="faService.faWeightHanging"></fa-icon>
                  </ion-col>
                  <ion-col size="2" class="verticalRight ion-no-padding " style="padding-right: 5px">
                    {{adjudicacion.cantidad | number:'1.2-2':'es' }} KG </ion-col>
                </ion-row>
                <ion-row>
                  <ion-col size="1" style="padding-left: 5px;">
                    <fa-icon class="icons-fa" [icon]="faService.faUser"></fa-icon>
                  </ion-col>
                  <ion-col size="8" class="verticalLeft ion-no-padding paddingRight">
                    {{adjudicacion.comprador }}
                  </ion-col>
                  <ion-col size="1">
                    <fa-icon class="icons-fa" [icon]="faService.fasCoins"></fa-icon>
                  </ion-col>
                  <ion-col size="2" class="verticalRight ion-no-padding " style="padding-right: 5px">
                    {{adjudicacion.precio |number:'1.2-2':'es' }} €
                  </ion-col>

                </ion-row>
              </ion-col>


            </ion-row>
          </ion-col>
        </ion-row>
        <ion-row style="background-color: white;" *ngIf="ventas.lenght==0">
          <ion-col>
            <ion-label>
              Aun no se ha realizado ninguna venta.
            </ion-label>
          </ion-col>
        </ion-row>
      </ion-col>
    </ion-row>
  </ion-grid>
</ion-content>